import React, { Component } from "react";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../sims/style";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { GCPSchema } from "./GCPSchema";
import { PillTextButton } from "../../../../libraries/GeneralButtons";
import { languageService } from "../../../../Language/language.service";
import { GCPMonthlySchema } from "./GCPMonthlySchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";

const masterKey = [
  { key: "C", value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },

  { key: "G", value: "Governed by Special Instruction." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant." },
  { key: "N", value: "Test Not Applicable." },
];

class ReportView extends Component {
  constructor(props) {
    super(props);
    this.state = { showMonthly: false, pillText: "Show Month Details" };
  }

  render() {
    let { data } = this.props;

    let formSummary = {};
    let showStandBySection = false;
    let fraHeaderInfo = data && data.length > 0 && data[0].fraHeaderInfo;
    data &&
      data.length > 0 &&
      data.forEach((item) => {
        const { month, summary } = item;

        for (let prop in summary) {
          if (!formSummary[prop]) {
            formSummary[prop] = {};
          }

          formSummary[prop][month] = summary[prop];

          //standBySection appFrom Ids end with S hence there is no need to maintain a separate list
          if (prop.endsWith("S") && !showStandBySection) {
            showStandBySection = true;
          }
        }
      });
    const sections = GCPSchema(showStandBySection);
    const monthlySections = GCPMonthlySchema(showStandBySection);
    return (
      <React.Fragment>
        <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
          <ReportTitleSection title="MS / GCP 3000 - INSPECTION AND TEST CARD" {...this.props} fontSizeOverride={"35px"} />
          <span className="spacer"></span>
          <ReportFraInfoSectionContainer {...this.props} data={{ fraHeaderInfo: fraHeaderInfo }} />
          <span className="spacer"></span>

          <table className="table-bordered" style={{ fontSize: "20px" }}>
            {sections.map((section) => {
              return <ReportTableSectionRenderer section={section} rowsData={formSummary} />;
            })}
          </table>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ marginTop: "-32px" }}>
              <ReportFraConditionsMasterKey masterKey={masterKey} />
            </div>
            <div>
              <div>
                {" "}
                <strong>Note: </strong> See Monthly Details for Inspectors Names, Dates and Comments{" "}
              </div>
              <div className="no-print">
                <PillTextButton
                  title={languageService(this.state.pillText)}
                  onClick={() =>
                    this.setState({
                      showMonthly: !this.state.showMonthly,
                      pillText: this.state.showMonthly ? "Show Month Details" : "Hide Month Details",
                    })
                  }
                  style={{ fontSize: "14px", width: "max-content", height: "40px", float: "right" }}
                />
              </div>
            </div>
          </div>
        </div>

        {this.state.showMonthly &&
          data &&
          data.length > 0 &&
          data.map((item) => {
            let month = new Date(item.year, item.month - 1, 1);
            const summary = {
              year: item.year,
              monthEn: month.toLocaleString("en-US", { month: "long" }).toLocaleUpperCase(),
              ...item.summary,
            };
            return (
              <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
                <ReportTitleSection
                  title="MS / GCP 3000 - INSPECTION AND TEST CARD"
                  subTitle={`Month: ${month.toLocaleString("en-US", { month: "long" })}`}
                  fontSizeOverride={"35px"}
                />

                <table className="table-bordered" style={{ fontSize: "20px" }}>
                  {monthlySections.map((section) => {
                    return <ReportTableSectionRenderer section={section} rowsData={summary} />;
                  })}
                </table>
                <ReportFraConditionsMasterKey masterKey={masterKey} />
              </div>
            );
          })}
      </React.Fragment>
    );
  }
}

const ETRGCPReport = (props) => {
  const { reportData, isPreview, selectedAsset } = props;
  if (isPreview) {
    return <ReportView data={{}} />;
  }
  let reportsByMonth = ReportGroupingUtils.groupReportsByMonth(reportData);

  return reportsByMonth && reportsByMonth.length > 0 && <ReportView {...props} data={reportsByMonth} />;
};

export default ETRGCPReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ETR/GCPReport/index.jsx